module.exports = __webpack_public_path__ + "img/naturals.4b461ce1.jpg";